var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51256 0.4375C7.00478 0.4375 9.02496 2.47178 9.02496 4.98103C9.02496 7.49027 7.00463 9.5244 4.51256 9.5244C2.02049 9.5244 0 7.49027 0 4.98103C0 2.47178 2.02033 0.4375 4.51256 0.4375ZM11.7188 0.703648C12.9649 0.703648 13.9751 2.6185 13.9751 4.98103H13.9752C13.9752 7.34294 12.9651 9.2584 11.7189 9.2584C10.4728 9.2584 9.46266 7.34294 9.46266 4.98103C9.46266 2.61912 10.4727 0.703648 11.7188 0.703648ZM15.2065 1.14917C15.6446 1.14917 16 2.86472 16 4.98103C16 7.09672 15.6448 8.81288 15.2065 8.81288C14.7681 8.81288 14.4131 7.09718 14.4131 4.98103C14.4131 2.86487 14.7683 1.14917 15.2065 1.14917Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.cd611086eab08a1136121a311b1b2ce9.svg";
export { ForwardRef as ReactComponent };